export const environment = {
	production: false,
	adobeKey: '4d631c19a81942ebb6479743617b696a',
	addAssetUrl: 'https://multiplai-dev-4p4hoaabuq-pd.a.run.app/add_asset',
	uploadUrl: 'https://multiplai-dev-4p4hoaabuq-pd.a.run.app/process',
	reUploadUrl: 'https://multiplai-dev-4p4hoaabuq-pd.a.run.app/reprocess',
	polygonUrl: 'https://multiplai-polygon-4p4hoaabuq-pd.a.run.app/polygon',
	aPolygonUrl: 'https://multiplai-polygon-4p4hoaabuq-pd.a.run.app/a_polygon',
	compileUrl: 'https://multiplai-dev-4p4hoaabuq-pd.a.run.app/compile',
	retryUrl: 'https://multiplai-dev-4p4hoaabuq-pd.a.run.app/retry',
	exportUrl: 'https://multiplai-dev-4p4hoaabuq-pd.a.run.app/export',
	validateUrl: 'https://multiplai-dev-4p4hoaabuq-pd.a.run.app/validate',
	aggregateUrl: 'https://multiplai-dev-4p4hoaabuq-pd.a.run.app/aggregate',
	deleteFileUrl: 'https://multiplai-dev-4p4hoaabuq-pd.a.run.app/delete_file',
	deleteDealUrl: 'https://multiplai-dev-4p4hoaabuq-pd.a.run.app/delete_deal',
	downloadFundFilesUrl: 'https://multiplai-dev-4p4hoaabuq-pd.a.run.app/download_files',
	downloadFilesUrl: 'https://multiplai-dev-4p4hoaabuq-pd.a.run.app/download_file',
	firebaseConfig: {
		apiKey: 'AIzaSyBnGNk-dysIoAGN81YVhXYWnFOBlfoeuKw',
		authDomain: 'multiplai-test.firebaseapp.com',
		projectId: 'multiplai-test',
		storageBucket: 'multiplai-test.appspot.com',
		messagingSenderId: '1059407816574',
		appId: '1:1059407816574:web:18ef7c0a7c711e23d9752f',
		measurementId: 'G-ZC84WV0W2J'
	},
};
